@if (!hideTitle) {
  <div class="title-container">
    <h3 class="title">
      {{ 'INVENTORY_UI.ACTIVE_ITEMS.TITLE' | translate }}
    </h3>
  </div>
}

@if (currentlyActiveItems$ | async; as items) {
  @if (items.length) {
    <inventory-ui-item-list [items]="items" [showStatus]="true" />
  } @else {
    <div class="no-items">
      {{ 'INVENTORY_UI.ACTIVE_ITEMS.NO_ACTIVE_ITEMS' | translate }}
    </div>
  }
}
